import { ChangeDetectionStrategy, Component, computed, inject, OnInit, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@client-monorepo/common/user';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';
import { LoginState, LoginStateService } from '@client-monorepo/applets/auth';
import { NgxFormValidator } from '@digipay/ngx-form-validator';
import { MessageService } from '@client-monorepo/common/utilities';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'auth-applet-enter-phone-number',
  standalone: true,
  imports: [CommonModule, FormsModule, UiFormFieldBuilderModule, ReactiveFormsModule, NgxButtonComponent],
  templateUrl: './enter-phone-number.component.html',
  styleUrl: './enter-phone-number.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterPhoneNumberComponent implements OnInit {
  form!: FormGroup;
  okReturned = output();
  LoginState = LoginState;

  authService = inject(AuthService);
  loginStateService = inject(LoginStateService);
  fb = inject(FormBuilder);
  messageService = inject(MessageService);
  presentativeCode = computed(() => this.loginStateService.presentativeCode());

  ngOnInit(): void {
    this.form = this.fb.group({
      phoneNumber: ['', [NgxFormValidator.cellNumberValidator()]],
    });
  }

  get getPhoneNumberValue(): string {
    return this.form.get('phoneNumber')?.value;
  }

  async getCode(): Promise<void> {
    if (this.form.invalid) {
      return;
    }

    try {
      const sendSms$ = await this.authService.getCode(
        this.getPhoneNumberValue,
        this.presentativeCode() ? this.presentativeCode() : undefined,
      );

      sendSms$.subscribe({
        next: (res) => {
          this.loginStateService.phoneNumber.set(this.getPhoneNumberValue);
          this.loginStateService.userId.set(res?.userId);
          this.loginStateService.isAutofill.set(res?.autofill);
          this.okReturned.emit();
        },
        error: (error) => {
          this.messageService.showErrorOfErrorResponse(error);
        },
      });
    } catch (error) {
      this.messageService.showErrorOfErrorResponse(error);
    }
  }

  goToStep(state: LoginState) {
    this.loginStateService.state.set(state);
  }

  checkKeyCode(event: KeyboardEvent) {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      this.getCode();
      return;
    }
  }
}
